export const BASE_URL = "https://edge.rima.soco.ude.systems";
export const BASE_URL_INTEREST = BASE_URL + "/api/interests/"

export const TOKEN = "cdf895267756d954747b63b9cc56e23fa06ecd29";
